import CIMSDivider from 'components/CIMSDivider'
import CIMSFormItem from 'components/CIMSFormItem'
import { useCIMSNotificationsPanelContext } from 'components/CIMSNotifications/components/CIMSNotificationsPanelContext'
import RecipientsSelect from 'components/CIMSSelect/common/RecipientsSelect'
import { HelpMessage } from 'utils/constants'
import ByResponseDisciplinesFormItem from './components/ByResponseDisciplinesFormItem'

const RenderFormItems: React.FC = () => {
  const { event } = useCIMSNotificationsPanelContext()
  return (
    <>
      <CIMSDivider
        help={HelpMessage.Notifications.Every(event, 'Request For Information')}
      >
        Every {event.name} Event
      </CIMSDivider>
      <CIMSFormItem label="Recipients" name="every">
        <RecipientsSelect />
      </CIMSFormItem>
      <CIMSDivider
        help={HelpMessage.RequestsForInformation.Notifications.ByResponseDiscipline(
          event
        )}
      >
        Response Disciplines
      </CIMSDivider>
      <CIMSFormItem name="responseDisciplines">
        <ByResponseDisciplinesFormItem />
      </CIMSFormItem>
    </>
  )
}

export default RenderFormItems
